/**
 * API 서버 설정 구성
 */
export const API_CONFIG = {
	auth: {
		baseUrl: process.env.NEXT_PUBLIC_STEPIN_AUTH,
		name: 'auth',
	},
	content: {
		baseUrl: process.env.NEXT_PUBLIC_STEPIN_CONTENT,
		name: 'content',
	},
	payment: {
		baseUrl: process.env.NEXT_PUBLIC_STEPIN_PAYMENT,
		name: 'payment',
	},
	search: {
		baseUrl: process.env.NEXT_PUBLIC_STEPIN_SEARCH,
		name: 'search',
	},
	system: {
		baseUrl: process.env.NEXT_PUBLIC_STEPIN_SYSTEM,
		name: 'system',
	},
	arcade: {
		baseUrl: process.env.NEXT_PUBLIC_STEPIN_ARCADE,
		name: 'arcade',
	},
} as const;

export type ServerName = keyof typeof API_CONFIG;
